<template>
  <div id="costPerMetricByUnitReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Cost Per Metric By Unit</div>
          <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'costPerMetricByUnitReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'costPerMetricByUnitReport'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                    mode="remote"
                    title="Cost Per Metric By Unit Report"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :paginationOptions="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        dropdownAllowAll: false,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                    }"
                    :search-options="{
                    enabled: false,
                    }"

                    >
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../mixins/commonMixins';
 import {dataTableMixins} from '../mixins/dataTableMixins';
export default {
  name: "NetBillingMetricsPeriod",
  metaInfo() {
            return {title: "Cost Per Metric By Unit Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    firstLoad: 0,
    cantAccessPage:"",
    loading: false,
    action:'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: "Reading From",
          field: "reading_out",
          hidden:false,
          fpFieldType:"integer",
          filterable: false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "All", // placeholder for filter input
            filterValue: " ", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: "Reading To",
          field: "reading_in",
          hidden:false,
          fpFieldType:"integer",
          filterable: true,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "All", // placeholder for filter input
            filterValue: " ", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Net Metric',
          field: 'net_metric',
          filterable: false,
          fpFieldType:"integer",
          hidden:false,
          sortable:false
      },
      {
          label: 'Total Cost',
          field: 'total_cost',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Total CPM',
          field: 'total_cpm',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Internal Cost',
          field: 'internal_cost',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Internal CPM',
          field: 'internal_cpm',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'External Cost',
          field: 'external_cost',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          width:'90px',
      },
      {
          label: 'External CPM',
          field: 'external_cpm',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Equipment Type Unit',
          field: 'asset_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Manufacturer Code',
          field: 'make',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Model',
          field: 'model',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Equipment Group',
          field: 'group',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'In Service Date',
          field: 'date_in_service',
          filterable: true,
          fpFieldType:"date",
          hidden:false,
      },
      {
          label: 'Equipment Year',
          field: 'year',
          fpFieldType:"integer",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Unit Status',
          field: 'unit_status',
          fpFieldType:"option",
          hidden: false,
          filterable: true,
      },
      {
          label: 'Unit Ownership',
          field: 'ownership',
          fpFieldType:"option",
          hidden: false,
          filterable: true,
      },
      {
          label: 'Unit Description',
          field: 'name',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Serial Number',
          field: 'vin',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      
      {
          label: 'Current Facility',
          field: 'location',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Current Pool',
          field: 'pool',
          fpFieldType:"option",
          hidden:false,
          // type:'number',
          filterable: false,
      },
      
        {
            label: "Customer Number",
            field: "customer_number",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Customer Name",
            field: "customer_name",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
          label: "Reading From",
          field: "start_date",
          filterable: false,
          fpFieldType:"date",
          hidden:true,
          sortable: false,
        },
        {
          label: "Reading To",
          field: "end_date",
          filterable: false,
          fpFieldType:"date",
          hidden:true,
          sortable: false,
        },
        {
          label: 'Metric Type',
          field: 'section',
          hidden:true,
          filterable: true,
          fpFieldType:"option",
      },
    ],
    batchProcess:0,
    batchNum:"",




  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'cost_per_metric_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{

    // exportReports: function() {
    //             this.action = "export";
    //             this.loadList();
    //         },

    loadList: function(){

      var self = this;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      self.firstLoad = 1;
      if (this.serverParams.columnFilters != undefined && this.serverParams.columnFilters[0].filterValue == null && this.serverParams.columnFilters[0].filterDateValue == null && this.serverParams.columnFilters[0].filterDateRangeValue == null && this.serverParams.columnFilters[0].filterOptionValue == null){
        return;
      }
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/cost-per-metric-by-unit-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action:self.action
        },
        success: function(data) {
          self.loading = false;
          // console.log(data.content.row);
          if (data.status == "success") {
            if (self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }

              self.action = "list";
              self.loadList();
          } else {

              console.log('success');

              if (data.content.row != undefined) {

                console.log("data.content.log");
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;

          }
        }
      },
      error: function(jqXHR, exception) {
        self.loading = false;
          self.generateStatusCodeMessage(jqXHR,true,'net-billing-metrics-report');
      }
    });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/CostPerMetricByUnitReport.vue